import $ from 'jquery'
import TemplateView from '../../TemplateView'
import ScrollableContainer from '../../util/ScrollableContainer'

export class DropdownOptionsSelector extends TemplateView {
    constructor({
        onSelectCallback = () => {}
    }) {
        super()

        this.params = {
            onSelectCallback
        }

        this.state = {
            options: [],
            selectedOption: '',
        }

        this.onStateChanged(() => {
            this._createContent()
        })
    }

    templateHtml() {
        return "<div class='components_dropdownOptionsSelector'></div>"
    }

    afterRender() {
        this._createContent()
    }

    update() {
        super.update()
        if (!!this.scrollableContainer)
            this.scrollableContainer.forceUpdate()
    }

    _createContent() {
        this.getEl().empty()
        this.scrollableContainer = new ScrollableContainer(
            null,
            new InnerList(this.params.onSelectCallback)
        ).init(this.getEl())
        this.scrollableContainer.setState({
            ...this.state
        })
    }
}

class InnerList extends TemplateView {
    constructor(onSelectOption) {
        super()
        this.onSelectOption = onSelectOption
        this.state = {
            options: [],
            selectedOption: []
        }

        this.onStateChanged(() => {
            this._renderList()
        })
    }

    templateHtml() {
        return "<div class='optionsList'></div>"
    }

    _renderList() {
        this.getEl().empty()
        this.state.options.forEach(option => {
            const $option = $("<div class='optionRow'></div>")
            $option.text(option)
            $option.appendTo(this.getEl())
            $option.toggleClass('selected', option === this.state.selectedOption)
            $option.click(() => this.onSelectOption(option))
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/customFields/components/DropdownOptionsSelector.js